import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'

import GenericNameField from 'components/form/GenericNameField'
import BrandedButton from 'components/BrandedButton'
import {
  QFF_LAST_NAME_KEY,
  QFF_NUMBER_KEY,
  QFF_SUCCESS_CONTAINER_ID,
} from 'containers/QantasFrequentFlyer/constants'
import styles from './styles.scss'

export default class QantasFrequentFlyerSimple extends PureComponent {
  render() {
    const {
      qffReducer,
      fieldError,
      lastNameLabel,
      qffLabel,
      submitLabel,
      successText,
      onSubmit,
      onFieldChangeHandler,
      onFieldBlur,
      fieldValues,
      isFormComplete,
      qffText,
    } = this.props
    const {
      isLoading,
      success,
      message,
    } = qffReducer

    const isFormCompleteClass = isFormComplete ? styles.form_complete : ''

    const responseMessageElement = message && !success && Object.keys(fieldError).length === 0
      ? <p className={styles.form_error}>{message}</p>
      : null

    let successComponent = null
    if (success) {
      successComponent = (
        <div className={styles.success_fields}>
          <div className={styles.success_field} >
            <div className={className(styles.field, styles.field_title)}>
              Qantas Frequent Flyer Number
            </div>
            <div className={className(styles.field, styles.field_value)}>
              {fieldValues[QFF_NUMBER_KEY]}
            </div>
          </div>
          <div className={styles.success_field} >
            <div className={className(styles.field, styles.field_title)}>
              Last Name
            </div>
            <div className={className(styles.field, styles.field_value)}>
              {fieldValues[QFF_LAST_NAME_KEY]}
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: qffText }}
        />
        <form
          className={className(styles.container, isFormCompleteClass)}
          onSubmit={onSubmit}
          method="POST"
        >
          <fieldset className={styles.form_container}>
            <legend>Signup for QFF:</legend>
            <div className={className(styles.field, styles.field_qff)}>
              <GenericNameField
                labelText={qffLabel}
                fieldName={QFF_NUMBER_KEY}
                onChange={onFieldChangeHandler}
                onBlur={onFieldBlur}
                value={fieldValues[QFF_NUMBER_KEY]}
                errorMessage={fieldError[QFF_NUMBER_KEY]}
                loading={isLoading}
                isRequired
              />
            </div>
            <div className={className(styles.field, styles.field_name)}>
              <GenericNameField
                labelText={lastNameLabel}
                fieldName={QFF_LAST_NAME_KEY}
                onChange={onFieldChangeHandler}
                onBlur={onFieldBlur}
                value={fieldValues[QFF_LAST_NAME_KEY]}
                errorMessage={fieldError[QFF_LAST_NAME_KEY]}
                loading={isLoading}
                isRequired
              />
            </div>
            <div className={styles.field_submit}>
              <BrandedButton labelText={submitLabel} loading={isLoading} />
            </div>
            {responseMessageElement}
          </fieldset>
          <div
            className={styles.success_container}
            id={QFF_SUCCESS_CONTAINER_ID}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: successText }}
          />
          {successComponent}
        </form>
      </div>
    )
  }
}

QantasFrequentFlyerSimple.propTypes = {
  qffReducer: PropTypes.shape({
    isLoading: PropTypes.bool,
    success: PropTypes.bool,
    message: PropTypes.string,
  }),
  fieldValues: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  fieldError: PropTypes.object,
  qffLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  successText: PropTypes.string,
  isFormComplete: PropTypes.bool,
  qffText: PropTypes.string,

  onSubmit: PropTypes.func,
  onFieldChangeHandler: PropTypes.func,
  onFieldBlur: PropTypes.func,
}

QantasFrequentFlyerSimple.defaultProps = {
  qffReducer: {
    isLoading: false,
    success: false,
    message: '',
  },
  fieldValues: {},
  fieldError: {},
  qffLabel: 'Qantas Frequent Flyer Number',
  lastNameLabel: 'Last Name',
  submitLabel: 'Link Account',
  successText: null,
  isFormComplete: false,
  qffText: '',

  onSubmit: f => f,
  onFieldChangeHandler: f => f,
  onFieldBlur: f => f,
}



// WEBPACK FOOTER //
// ./components/QantasFrequentFlyerSimple/index.jsx